module.exports = __webpack_public_path__ + "static/img/6.815afec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/sp/6.png
// module id = /oc3
// module chunks = 0